<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl" :footer="widget.footer">
        <dt>
            <p class="text-sm font-medium text-gray-500 truncate">
                {{ $t('messages.this_trimester') }}
            </p>
        </dt>
        <dd class="pb-6 flex items-baseline sm:pb-7">
            <p class="text-2xl font-semibold text-gray-900">
                {{ widget.content.trimesterCount }}
            </p>
        </dd>

        <div>
            {{ widget.content.period }}
        </div>
        <div>
            <apexchart
                :type="widget.content.chartData.chart.type"
                :height="150"
                :series="widget.content.chartData.series"
                :options="widget.content.chartData"
            >
            </apexchart>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
export default {
    name: 'UsageSparklineGraphWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        BaseWidget,
    },
};
</script>
